import React from 'react'
import './Home.css'
import BannerSupport from './BannerSupport'
import SupportScreen from './SupportScreen'

function Support() {
    return (
        <div className='home'>
            <BannerSupport />
            <SupportScreen />
        </div>
    )
}

export default Support
